import api from "../api";
import business_id from "../business"
import { toast } from 'vue3-toastify'

export default {
  namespaced: true,
  state: {
    ads: {},
    featuredAds: {},
    featuredPaginate: {},
    ad: {},
    adStates: {},
    paginate: {},
    cities: {},
    states: {},
    categoryAds: {},
    store: {},
    adCondition: {},
    period: {},
    totalQuantity: 0,
    totalValue: 0,
    availableCount: 0,
    pausedCount: 0
  },
  getters: {

  },
  actions: {
    async get_ads({ commit }, payload = []) {
      try {

        //frete gratis
        let address = JSON.parse(sessionStorage.getItem("zipcodedefault"))?.uf || false
        payload.uf = address

        api.post(`/v1/${business_id}/ads/paginate`, payload)
          .then((res) => {
            commit("GET_ADS", res.data);
          })
          .catch((error) => {
            commit("ERROR_AD", "Erro ao carregar as ads");
          })
          .finally(() => (
            // this.loading = false
            console.log('login request end')
          ));
      } catch (e) {
        commit("ERROR_AD", e);
      }
    },

    async get_featured_ads({ commit }, payload = []) {
      try {

        //frete gratis
        let address = JSON.parse(sessionStorage.getItem("zipcodedefault"))?.uf || false
        payload.uf = address

        api.post(`/v1/${business_id}/ads-featureds`, payload)
          .then((res) => {
            commit("GET_FEATURED_ADS", res.data);
          })
          .catch((error) => {
            commit("ERROR_AD", "Erro ao carregar as ads");
          })
          .finally(() => (
            // this.loading = false
            console.log('login request end')
          ));
      } catch (e) {
        commit("ERROR_AD", e);
      }
    },

    async get_ad({ commit }, id) {
      try {

        //frete gratis
        let address = JSON.parse(sessionStorage.getItem("zipcodedefault"))?.uf || false
        let payload = {}
        payload.uf = address

        api.post(`/v1/${business_id}/ads-show/${id}`, payload)
          .then((res) => {
            commit("SHOW_AD", res?.data);
          })
          .catch((error) => {
            commit("ERROR_AD", "Algo deu errado, entre em contato com os desenvolvedores");
          })
          .finally(() => (
            // this.loading = false
            console.log('')
          ));
      } catch (e) {
        commit("ERROR_AD", "Algo deu errado, entre em contato com os desenvolvedores" + e);
      }
    },

    async get_store_ads({ commit }, payload = []) {
      try {

        api.post(`/v1/${business_id}/ads/paginate-to-store`, payload)
          .then((res) => {
            commit("GET_ADS", res.data);
          })
          .catch((error) => {
            commit("ERROR_AD", "Erro ao carregar as ads");
          })
          .finally(() => (
            // this.loading = false
            console.log('login request end')
          ));
      } catch (e) {
        commit("ERROR_AD", e);
      }
    },

    async get_states({ commit }) {
      try {
        api.get(`/v1/states-ads`)
          .then((res) => {
            commit("GET_STATES", res.data);
          })
          .catch((error) => {
            commit("ERROR_STATE", "Erro ao carregar as states");
          })
          .finally(() => (
            // this.loading = false
            console.log('login request end')
          ));
      } catch (e) {
        commit("ERROR_STATE", e);
      }
    },

    async get_cities({ commit }, payload) {
      try {
        api.get(`/v1/cities/state-ads/${payload}`)
          .then((res) => {
            commit("GET_CITIES", res.data);
          })
          .catch((error) => {
            commit("ERROR_CITY", "Erro ao carregar as cities");
          })
          .finally(() => (
            // this.loading = false
            console.log('login request end')
          ));
      } catch (e) {
        commit("ERROR_CITY", e);
      }
    },

    async get_categoryAds({ commit }) {
      try {
        api.get(`/v1/${business_id}/categoryAds`)
          .then((res) => {
            commit("GET_CATEGORYADS", res.data);
          })
          .catch((error) => {
            commit("ERROR_CATEGORY", "Erro ao carregar as categoryAds");
          })
          .finally(() => (
            // this.loading = false
            console.log('login request end')
          ));
      } catch (e) {
        commit("ERROR_CATEGORY", e);
      }
    },

    async get_adConditions({ commit }) {
      try {
        api.get(`/v1/${business_id}/adConditions`)
          .then((res) => {
            commit("GET_ADCONDITIONS", res.data);
          })
          .catch((error) => {
            commit("ERROR_CONDITION", "Erro ao carregar as conditionAds: " + error);
          })
          .finally(() => (
            // this.loading = false
            console.log('login request end')
          ));
      } catch (e) {
        commit("ERROR_CONDITION", e);
      }
    },

    async get_period({ commit }) {
      try {
        api.get(`/v1/periods`)
          .then((res) => {
            commit("GET_PERIOD", res.data);
          })
          .catch((error) => {
            commit("ERROR_PERIOD", "Erro ao carregar os periods");
          })
          .finally(() => (
            // this.loading = false
            console.log('login request end')
          ));
      } catch (e) {
        commit("ERROR_PERIOD", e);
      }
    },

    async create_ads({ dispatch, commit }, payload = []) {
      try {
        return api.post(`/v1/${business_id}/create-ads`, payload)
          .then((res) => {
            if (res?.data?.error) {
              console.log(res?.data)
              //dispatch("alert/set_alert", {alert_message: "Erro ao salvar, aguarde e tente mais tarde", type_message: 'alert-danger'}, { root: true });

              //if (window.innerWidth < 480) {
              toast.warning(res?.data?.message, {
                type: 'default',
                theme: 'colored',
                hideProgressBar: true,
                dangerouslyHTMLString: true
              });
              //}

            } else {
              if (res?.data) {
                //dispatch("alert/set_alert", {alert_message: "Salvo com sucesso: assim que sua sugestão for aprovada, você será notificado", type_message: 'alert-success'}, { root: true });

                toast.success(res?.data?.message, {
                  type: 'default',
                  theme: 'colored',
                  hideProgressBar: true,
                  dangerouslyHTMLString: true
                });
              }
            }
            return res.data


          })
          .catch((error) => {
            commit("ERROR_ADD_ADS", "Erro ao carregar");
            //dispatch("alert/set_alert", {alert_message: error.response.data.message, type_message: 'alert-warning'}, { root: true });

            //if (window.innerWidth < 480) {
            toast.warning(error.response.data.message, {
              type: 'default',
              theme: 'colored',
              hideProgressBar: true,
              dangerouslyHTMLString: true
            });
            //}

          })
          .finally(() => (
            // this.loading = false
            console.log('login request end')
          ));
      } catch (e) {
        commit("ERROR_ADD_ADS", e);
      }
    },

    async update_ads({ dispatch, commit }, payload = []) {
      try {
        return api.post(`/v1/${business_id}/update-ads`, payload)
          .then((res) => {
            if (res?.data?.error) {
              console.log(res?.data)
             
              toast.warning(res?.data?.message, {
                type: 'default',
                theme: 'colored',
                hideProgressBar: true,
                dangerouslyHTMLString: true
              });

            } else {
              if (res?.data) {

                toast.success(res?.data?.message, {
                  type: 'default',
                  theme: 'colored',
                  hideProgressBar: true,
                  dangerouslyHTMLString: true
                });
              }
            }
            return res.data

          })
          .catch((error) => {
            commit("ERROR_UPT_ADS", "Erro ao carregar");
            //dispatch("alert/set_alert", {alert_message: error.response.data.message, type_message: 'alert-warning'}, { root: true });

            //if (window.innerWidth < 480) {
            toast.warning(error.response.data.message, {
              type: 'default',
              theme: 'colored',
              hideProgressBar: true,
              dangerouslyHTMLString: true
            });
            //}

          })
          .finally(() => (
            // this.loading = false
            console.log('login request end')
          ));
      } catch (e) {
        commit("ERROR_UPT_ADS", e);
      }
    },

    async change_status({ dispatch, commit }, payload) {
      try {
        return api.post(`/v1/${business_id}/change-status`, payload)
          .then((res) => {
            if (res?.data?.error) {
              console.log(res?.data)
             
              toast.warning(res?.data?.message, {
                type: 'default',
                theme: 'colored',
                hideProgressBar: true,
                dangerouslyHTMLString: true
              });

            } else {
              if (res?.data) {

                toast.success(res?.data?.message, {
                  type: 'default',
                  theme: 'colored',
                  hideProgressBar: true,
                  dangerouslyHTMLString: true
                });
              }
            }
            return res.data
            //}

          })
          .catch((error) => {
            commit("ERROR_ADS", "Erro ao carregar");
            //dispatch("alert/set_alert", {alert_message: error.response.data.message, type_message: 'alert-warning'}, { root: true });

            //if (window.innerWidth < 480) {
            toast.warning(error.response.data.message, {
              type: 'default',
              theme: 'colored',
              hideProgressBar: true,
              dangerouslyHTMLString: true
            });
            //}

          })
          .finally(() => (
            // this.loading = false
            console.log('login request end')
          ));
      } catch (e) {
        commit("ERROR_ADS", e);
      }
    },

    async delete_ads({ dispatch, commit }, id) {
      try {
        return api.post(`/v1/${business_id}/delete-ads`, { id: id })
          .then((res) => {
            if (res?.data?.error) {
              console.log(res?.data)
             
              toast.warning(res?.data?.message, {
                type: 'default',
                theme: 'colored',
                hideProgressBar: true,
                dangerouslyHTMLString: true
              });

            } else {
              if (res?.data) {

                toast.success(res?.data?.message, {
                  type: 'default',
                  theme: 'colored',
                  hideProgressBar: true,
                  dangerouslyHTMLString: true
                });
              }
            }
            return res.data
            //}

          })
          .catch((error) => {
            commit("ERROR_ADS", "Erro ao carregar");
            //dispatch("alert/set_alert", {alert_message: error.response.data.message, type_message: 'alert-warning'}, { root: true });

            //if (window.innerWidth < 480) {
            toast.warning(error.response.data.message, {
              type: 'default',
              theme: 'colored',
              hideProgressBar: true,
              dangerouslyHTMLString: true
            });
            //}

          })
          .finally(() => (
            // this.loading = false
            console.log('login request end')
          ));
      } catch (e) {
        commit("ERROR_ADS", e);
      }
    },

    async destroy_ads({ dispatch, commit }, id) {
      try {
        api.post(`/v1/${business_id}/destroy-ads`, { id: id })
          .then((res) => {
            if (res?.data?.error) {
              console.log(res?.data)
             
              toast.warning(res?.data?.message, {
                type: 'default',
                theme: 'colored',
                hideProgressBar: true,
                dangerouslyHTMLString: true
              });

            } else {
              if (res?.data) {

                toast.success(res?.data?.message, {
                  type: 'default',
                  theme: 'colored',
                  hideProgressBar: true,
                  dangerouslyHTMLString: true
                });
              }
            }
            return res.data
          })
          .catch((error) => {
            commit("ERROR_DELETE_ADS", error);

            toast.warning(error.response.data.message, {
              type: 'default',
              theme: 'colored',
              hideProgressBar: true,
              dangerouslyHTMLString: true
            });

            //dispatch("alert/set_alert", {alert_message: "Existem pedidos com esse item, nao pode ser removido", type_message: 'alert-warning'}, { root: true });

          })
          .finally(() => (
            // this.loading = false
            console.log('login request end')
          ));
      } catch (e) {
        commit("ERROR_DELETE_ADS", e);
      }
    },

  },
  mutations: {
    GET_ADS(state, data) {
      if (data?.paginate.current_page == 1) {
        console.log("dentro pagina 1")
        state.ads = data?.products || []
      } else {
        console.log("dentro outras paginas")
        state.ads.push(...data?.products)
      }  
      state.paginate = data?.paginate
      state.store = data?.store
      state.adCondition = data?.adCondition,
      state.totalQuantity = data?.totalQuantity,
      state.totalValue = data?.totalValue,
      state.availableCount = data?.availableCount,
      state.pausedCount = data?.pausedCount
    },
    GET_FEATURED_ADS(state, data) {
      if (data?.paginate.current_page == 1) {
        state.featuredAds = data?.products || []
      } else {
        state.featuredAds.push(...data?.products)
      }  
      state.featuredPaginate = data?.paginate
    },

    SHOW_AD(state, data) {
      state.ad = data
    },

    ERROR_AD(state, data) {
      console.log(data)
    },

    GET_STATES(state, data) {
      state.states = data
    },
    ERROR_STATE(state, data) {
      console.log(data)
    },

    GET_AD_STATES(state, data) {
      state.adStates = data
    },
    ERROR_AD_STATE(state, data) {
      console.log(data)
    },

    GET_CITIES(state, data) {
      state.cities = data
    },
    ERROR_CITY(state, data) {
      console.log(data)
    },

    GET_CATEGORYADS(state, data) {
      state.categoryAds = data
    },
    ERROR_CATEGORY(state, data) {
      console.log(data)
    },

    GET_ADCONDITIONS(state, data) {
      state.adCondition = data
    },
    ERROR_CONDITION(state, data) {
      console.log(data)
    },

    GET_ADD_ADS(state, data) {
      state.ad = data
      //location.reload()
    },
    ERROR_ADD_ADS(state, data) {
      console.log(data)
    },

    GET_UPT_ADS(state, data) {
      state.ad = data
      //location.reload()
    },
    ERROR_UPT_ADS(state, data) {
      console.log(data)
    },

    GET_PERIOD(state, data) {
      state.period = data
    },
    ERROR_PERIOD(state, data) {
      console.log(data)
    },

    ERROR_DELETE_ADS(state, data) {
      console.log(data)
    },

    /*GET_AD_FULL(state, data) {
      state.ad = data
    },
    ERROR_AD_FULL(state, data){
      console.log(data)
    },*/
  }
}